import {Component} from 'react';

export default class SilentSubmitHandler extends Component {
  componentWillUnmount() {
    this.props.onSubmit(this.props.values, this.props.shumaId, this.props.dirty)
  }
  render() {
    return null
  }
}



